import React from 'react';
import styled from 'styled-components';

export const ProfileImage = styled.img`
  border-radius: 20px;
  width: 40px;
`;
